import { useState, useEffect } from 'react';
import Modal from '@shared/components/atoms/Modal/Modal';
import Button from '@shared/components/atoms/Button';
import { useUpdateInquiryMutation } from '@features/inquiry/hooks';

import styles from '@pages/admin/inquiry/components/InquiryDetaiModal.module.scss';

export default function InquiryDetailModal({
  isOpen,
  onClose,
  inquiryData,
  onUpdated,
  onError,
  onAlert,
}) {
  if (!isOpen) return null;

  const [status, setStatus] = useState('0');
  const [comment, setComment] = useState('');
  const MAX_COMMENT_LENGTH = 1000;

  useEffect(() => {
    if (inquiryData) {
      setStatus(String(inquiryData.status ?? '0'));
      setComment(inquiryData.comment ?? '');
    }
  }, [inquiryData]);

  const { mutate: updateInquiryMutate, isLoading } = useUpdateInquiryMutation({
    onSuccess: () => {
      onUpdated?.();
      onClose();
    },
    onError: () => {
      onError?.();
    },
  });

  const handleSave = () => {
    updateInquiryMutate({
      idx: inquiryData.idx,
      payload: {
        status: Number(status),
        comment: comment,
      },
    });
  };
  function handleCommentPaste(e) {
    const pasteData = e.clipboardData?.getData('text') || '';
    const currentValue = comment || '';

    const target = e.target;
    const selectionStart = target.selectionStart ?? 0;
    const selectionEnd = target.selectionEnd ?? 0;

    const before = currentValue.substring(0, selectionStart);
    const after = currentValue.substring(selectionEnd);

    const expectedValue = before + pasteData + after;

    if (expectedValue.length > MAX_COMMENT_LENGTH) {
      e.preventDefault();
      onAlert?.(`코멘트는 최대 ${MAX_COMMENT_LENGTH}자까지 입력할 수 있습니다.`);
    }
  }
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="문의 사항"
      size="medium"
      closeOnOverlayClick={false}
      showCloseButton
    >
      <table className={styles.modalContent}>
        <tbody>
          <tr>
            <td>문의 유형</td>
            <td>
              {{
                1: '서비스 불편 / 제안',
                2: '시스템 오류 (PC/Mobile)',
                3: '서비스 개선 제안',
                4: '기타',
              }[inquiryData.inquiryType] ?? '-'}
            </td>
          </tr>
          <tr>
            <td>문의 회사</td>
            <td>{inquiryData.companyName}</td>
          </tr>
          <tr>
            <td>문의 부서</td>
            <td>{inquiryData.teamName}</td>
          </tr>
          <tr>
            <td>문의자</td>
            <td>{inquiryData.writerName}</td>
          </tr>
          <tr className={styles.textareaArea}>
            <td>문의 내용</td>
            <td>{inquiryData.inquiryContent}</td>
          </tr>
          <tr>
            <td>진행상태</td>
            <td>
              <select
                className={styles.select}
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="0">접수</option>
                <option value="1">처리중</option>
                <option value="2">처리완료</option>
                <option value="3">반려</option>
              </select>
            </td>
          </tr>
          <tr className={styles.textareaArea}>
            <td>답변</td>
            <td>
              <textarea
                className={styles.textarea}
                value={comment}
                maxLength={MAX_COMMENT_LENGTH}
                onPaste={handleCommentPaste}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length > MAX_COMMENT_LENGTH) return;
                  setComment(value);
                }}
                placeholder="코멘트를 입력해주세요."
              />
              <div className={styles.charCounter}>
                <span className={comment?.length >= MAX_COMMENT_LENGTH ? styles.limitReached : ''}>
                  {comment?.length || 0}
                </span>
                /{MAX_COMMENT_LENGTH}자
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div className={styles.buttonGroup}>
        <Button className={styles.cancelButton} onClick={onClose}>
          취소
        </Button>
        <Button className={styles.saveButton} onClick={handleSave} disabled={isLoading}>
          확인
        </Button>
      </div>
    </Modal>
  );
}
